MutationObserver = window.MutationObserver;

const observer = new MutationObserver(mutations => {
	mutations.forEach(mutation => {
		mutation.addedNodes.forEach(node => {
			toggleProductDataBySku(node);
		});
	});
});

const toggleProductDataBySku = node => {
	if (!node.parentElement || !node.parentElement.classList.contains('sku')) {
		return;
	}
	document.querySelectorAll('[data-variation-id]').forEach(element => {
		element.style.display = 'none';
		if (element.getAttribute('data-variation-id') === node.nodeValue) {
			element.style.display = 'block';
		}
	});
}

const target = document.querySelector('.product-type-variable .summary');

if (target) {
	observer.observe(target, {
		childList: true,
		subtree: true,
		attributes: false,
		characterData: false,
	});
}
